var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('regist-success',{attrs:{"step":_vm.step,"isActived":_vm.isActived,"success":_vm.isActived,"text1":_vm.text1,"text2":_vm.text2,"text3":_vm.text3,"text4":_vm.text4,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }